<form (ngSubmit)="onSubmit(searchSortForm)" method="GET" action="/{{locale}}/studio/store" [formGroup]="searchSortForm"
    id="nvSTDsearchform">
    <div class="form-row">
        <div class="search-form-container form-group">
            <input id="srchBox" class="search-input search-input-text search-helper-text form-control" type="text"
                formControlName="search" autocomplete="off" placeholder="{{ 'search_placeholder' | translate }}"><span
                class="form-control-clear glyphicon glyphicon-remove form-control-feedback hidden"
                (click)="clearSearch(searchSortForm)"></span>
            <input type="submit" id="stschsb" class="submit-button">
        </div>
    </div>
    <div class="form-row">
        <div class="bounding-box">
            <div class=sort-section>
                <label class="sort-label">{{ 'sort_by' | translate }}:</label>
                <simple-dropdown *ngIf="productSort.length" [totalProducts]="totalProducts" [productSort]="productSort"
                    (optionChange)="onSort($event)"></simple-dropdown>
            </div>
            <div class="grid-container search-container">
                <label class="search-label">{{ 'view' | translate }}:</label>
                <button kuiButton type="button" (click)="updateView($event, 'list')" [size]="'tiny'" [danger]="false"
                    [type]="'tertiary'"
                    [ngClass]="currentView === 'list' ? 'list-view-active' : 'list-view-default'"></button>
                <button kuiButton type="button" (click)="updateView($event, 'grid')" [size]="'tiny'" [danger]="false"
                    [type]="'tertiary'"
                    [ngClass]="currentView === 'grid' ? 'grid-view-active' : 'grid-view-default'"></button>
            </div>
        </div>
    </div>
</form>